import styled from '@emotion/styled';
import React, { ReactElement } from 'react';
import { Progress } from '../Progress/component';
import { ProgressProps } from './types';

const LabelRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const TopRow = styled(LabelRow)({
  marginBottom: 8,
});

const BottomRow = styled(LabelRow)({
  marginTop: 8,
});

const Container = styled('div')({
  border: '1px solid rgba(0, 0, 0, 0.1)',
  borderRadius: 4,
  padding: '20px 28px',
  marginTop: 20,
  marginBottom: 20,
});

const Label = styled('span')({
  fontSize: 16,
});

const BoldText = styled('span')({
  fontWeight: 600,
});

export const UsageProgress = ({
  label,
  currentPeriodLabel,
  usageResetLabel,
  value,
  max,
  barLabels,
}: ProgressProps): ReactElement => {
  return (
    <Container>
      <TopRow>
        <BoldText>
          <Label>{label}</Label>
        </BoldText>
        <Label>
          <BoldText>
            {value.length > 0 ? value.reduce((a, b) => a + b) : 0}
          </BoldText>{' '}
          of <BoldText>{max || 'unlimited'}</BoldText>
        </Label>
      </TopRow>
      <Progress values={value} max={max} />
      <BottomRow>
        <Label>{currentPeriodLabel}</Label>
        {usageResetLabel && (
          <Label>
            <BoldText>Usage resets on:</BoldText> {usageResetLabel}
          </Label>
        )}
      </BottomRow>
      {barLabels}
    </Container>
  );
};
